
import { defineComponent } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import BoundaryInfo from '@/components/layout/BoundaryInfo.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'

/**
 * 境界立会申請件名新規登録
 */
export default defineComponent({
  name: 'BoundaryAdd',
  components: {
    UserLoginWrapper,
    BoundaryInfo,
    DoubleScroll,
  },
})
